
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MeAvise } from '@app/models/me-avise';


import { ServiceBase } from '@app/services/base.service';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';

@Injectable()
export class ProcessoMovimentacaoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  // adicionar(processo: ProcessoMovimentacao): Observable<any> {
  //   return this.http.post<any>(this.URL_API + 'ProcessoMovimentacao', processo).pipe(
  //     catchError((error: any) => observableThrowError(error)));
  // }


  // adicionarFormData(formData: FormData): Observable<any> {
  //   // let headers = new Headers({ 'charset': 'utf-8' });
  //   // headers.append('Cache-Control', 'no-cache');
  //   // headers.append('Pragma', 'no-cache');
  //   // headers.append('Content-Type', 'multipart/form-data')
  //   // let options = new RequestOptions({ headers: headers });
  //   return this.http.post<any>(this.URL_API + 'ProcessoMovimentacao',
  //     formData, { headers: { meta: ['upload'] } }).pipe(
  //       catchError((error: any) => observableThrowError(error)));
  // }

  // alterar(processo: ProcessoMovimentacao): Observable<any> {
  //   return this.http.put<any>(this.URL_API + 'ProcessoMovimentacao', processo).pipe(
  //     catchError((error: any) => observableThrowError(error)));
  // }

  // // deletar(id: number) {
  // //   return this.http.delete(this.URL_API + `ProcessoMovimentacao/${id}`);
  // // }

  // obterPorId(tipoMovimentacao: TipoMovimentacao, id: number): Observable<any> {
  //   return this.http.get<any>(this.URL_API + `ProcessoMovimentacao/Obter/${tipoMovimentacao}/${id}`);
  // }
  // obterTodos(): Observable<any> {
    //   return this.http.get<any>(this.URL_API + 'ProcessoMovimentacao/');
    // }

  // obterPorProcesso(tipoMovimentacao: TipoMovimentacao, id: number, quantidade: number = 0): Observable<any> {
    //   return this.http.get<any>(this.URL_API + `ProcessoMovimentacao/ObterPorProcesso/${tipoMovimentacao}/${id}/${quantidade}`);
  // }
  // obterHistoricoMovimentacoes(tipoMovimentacao: TipoMovimentacao, processoId: number): Observable<any> {
  //   return this.http.get<any>(this.URL_API + `ProcessoMovimentacao/ObterHistoricoMovimentacoes/${tipoMovimentacao}/${processoId}`);
  // }

  //obterArquivo(id: number): Observable<any> {
  //  return this.http.get<any>(this.URL_API + `Processo/ObterArquivo/${id}`);
  //}

  //Em uso
  obterDescricaoMovimentacaoPorId(idMovimentacao: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `ProcessoMovimentacao/obterDescricaoMovimentacaoPorId/${idMovimentacao}`);
  }

  obterMeAvise(id: number,): Observable<any> {
    return this.http.get<any>(this.URL_API + `ProcessoMovimentacao/ObterMeAvise/${id}`);
  }

  adicionarMeAvise(meAvise: MeAvise): Observable<any> {
    return this.http.post<any>(this.URL_API + `ProcessoMovimentacao/AdicionarMeAvise`, meAvise).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  alterarMeAvise(meAvise: MeAvise): Observable<any> {
    return this.http.put<any>(this.URL_API + `ProcessoMovimentacao/AlterarMeAvise`, meAvise).pipe(
      catchError((error: any) => observableThrowError(error)));
  }
}
